App.controller('GeneralCtrl', ['$rootScope', '$scope', '$sce', '$state', '$http', '$window', 'Config', 'authService', 'profileService', 'dataUser', 'subscription', '$mdDialog', 'windowDimensions', '$base64', '$stateParams', function ($rootScope, $scope, $sce, $state, $http, $window, Config, authService, profileService, dataUser, subscription, $mdDialog, windowDimensions, $base64, $stateParams) {
   	$scope.page = 'root';
    $scope.$on('page', function (evnt, data) {
        $scope.page = data;
    });

    $scope.step = '';
    $scope.$on('step', function (evnt, data) {
        $scope.step = data;
    });

    $scope.link = 'root.home.dashboard';
    $scope.$on('link', function (evnt, data) {
        $scope.link = $state.href(data, {}, {absolute: true});
    });

    $scope.send = function(login, password) {
        var vm = this;

        if (!vm.form.$valid) {
            return 0;
        }

        authService.authenticate(login, password).then(function (data) {
            if (data.status === 200) {
                window.sessionStorage.setItem('isLogged', data.data.access_token);
                window.sessionStorage.setItem('refresh_token', data.data.refresh_token);
                // @TODO <HEALTH2019>
                var expiresInSeconds = data.data.expires_in;
                var time = new Date().getTime();
                window.sessionStorage.setItem('refresh_time',  time + expiresInSeconds * 1000);
                // @TODO </HEALTH2019>

                profileService.dataUser().then(function (data) {
                    if (data.status === 200) {
                        dataUser.update(true, $stateParams);
                    }
                });
            } else {
                if (data.data.error_description && data.data.error_description === 'blocked') {
                    $scope.showPopUp('', 'Błąd logowania', 'Z powodu trzykrotnego błędnego podania hasła/loginu, możliwość logowania została zawieszona na 10 minut. Spróbuj ponownie później.', '', '');
                } else {
                    $scope.showPopUp('', 'Błąd logowania', 'Dane są nieprawidłowe lub konto nie zostało aktywowane. W przypadku problemów, prosimy o kontakt.', '', '');
                }
            }
        });
    };

    $scope.logout = function() {
        authService.logout().then(function (data) {
            if (data.status === 200) {
                dataUser.clearSession();
                $state.go('root.login');
            } else {
                // $scope.showPopUp('', 'Błąd wylogowania', 'Nie udało sie poprawnie wylogować konta. W przypadku problemów, prosimy o kontakt.', '', '');
                dataUser.clearSession();
                $state.go('root.login');
            }
        });
    };

    $scope.showPopUp = function(ev, head, content, text, target) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function(data) {

        }, function() {

        });
    };

    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function() {
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.confirm = function() {
            $mdDialog.hide($scope.locals);
        };
    }
    PopUpInfoCtrl.$inject = ['$scope', '$mdDialog', 'locals'];

    $scope.offsetWidth = windowDimensions.width();
    angular.element($window).on('resize', function () {
        $scope.offsetWidth = windowDimensions.width();
        $scope.$apply();
    });

    $scope.loaderDisabled = true;
    $scope.loaderActivated = false;
    $scope.loaderActivatedInfo = '';
    $scope.$on('loaderActivated', function (evnt, data) {
        $scope.loaderActivated = data.status;
        $scope.loaderActivatedInfo = (!data.info) ? $scope.loaderActivatedInfo : data.info;

        checkLoader($scope.loaderActivated);
    });

    $rootScope.$$listeners.$stateChangeStart = [];
    $rootScope.$on('$stateChangeStart', function() {
        $scope.loaderActivated = true;
        $scope.loaderActivatedInfo = 'Ładuje dane...';

        // TODO-MZ
        checkLoader($scope.loaderActivated);
    });

    $rootScope.$on('$stateChangeSuccess', function() {
        $scope.loaderActivated = false;

        // TODO-MZ
        checkLoader($scope.loaderActivated);
    });

    function checkLoader(status) {
        if (status) {
            $scope.loaderDisabled = true;
            $('.preloader').velocity("stop", true).velocity("fadeIn", { delay: 0, duration: 1 });
        } else {
            $('.preloader').velocity("fadeOut", { delay: 100, duration: 500 });
            $scope.loaderDisabled = false;
        }
    }
}]);
